/**
 * Parse American odds from API display (e.g. "+150", "-200") for numeric sorting.
 *
 * @param {string | null | undefined} display
 * @returns {number | null}
 */
export function americanOddsDisplayToSortNumber(display) {
  if (display == null || String(display).trim() === '') return null;
  const parsed = parseFloat(String(display).trim());
  return Number.isFinite(parsed) ? parsed : null;
}

/**
 * Compare two possibly-null numbers; null / non-finite values sort last for both directions.
 *
 * @param {number | null} a
 * @param {number | null} b
 * @param {'asc' | 'desc'} direction
 * @returns {number}
 */
export function compareNullableNumbersForSort(a, b, direction) {
  const aOk = a != null && Number.isFinite(a);
  const bOk = b != null && Number.isFinite(b);
  if (!aOk && !bOk) return 0;
  if (!aOk) return 1;
  if (!bOk) return -1;
  const cmp = a - b;
  return direction === 'asc' ? cmp : -cmp;
}
